export type TWeekDays = 'SUNDAY' | 'MONDAY' | 'TUESDAY' | 'WEDNESDAY' | 'THURSDAY';

export type Lesson = {
  id: number;
  startDate: string;
  endDate: string;
  name: string;
  nameHebrew: string;
  teacherId: number;
  roomId: number;
  dayOfWeek: TWeekDays;
  startTime: string;
  endTime: string;
  isOnline: boolean;
  maxStudents: number;
  minAge: number;
  maxAge: number;
  oldBookingDate?: string;
  oldEndTime?: string;
  oldScheduleId?: number;
  oldStartTime?: string;
};

export enum WeekDays {
  'SUNDAY',
  'MONDAY',
  'TUESDAY',
  'WEDNESDAY',
  'THURSDAY',
  'FRIDAY',
  'SATURDAY'
}

export type LessonGroup = {
  startTime: string;
  rooms: {
    roomId: number | null;
    entries: Lesson[];
  }[];
  rowspan: number;
};
